module.exports = __webpack_public_path__ + "img/niklas.7a1a9fe1.png";